import { adapterClient, handleApiError } from './client';
import { canonicalProjectId } from './projectViews';
import {
  balanceViewSchema,
  depositViewSchema,
  withdrawalViewSchema,
} from '@/types/current-finance';
import { useAuthStore } from '@/stores/authStore';

export async function getBalance(signal?: AbortSignal) {
  const account = useAuthStore.getState().session?.accountId;
  try {
    const { data } = await adapterClient.get<unknown>('/balance', { signal });
    const result = balanceViewSchema.safeParse(data);
    if (!result.success || result.data.account !== account)
      throw new Error(
        'The server returned an invalid balance for this account.'
      );
    return result.data;
  } catch (error) {
    handleApiError(error, 'balance');
  }
}
export async function getRampRequest(
  kind: 'deposit' | 'withdrawal',
  id: string,
  signal?: AbortSignal
) {
  const session = useAuthStore.getState().session;
  const requestId = canonicalProjectId(id);
  try {
    const { data } = await adapterClient.get<unknown>(
      '/bramp/' + kind + 's/' + requestId,
      { signal }
    );
    const result =
      kind === 'deposit'
        ? depositViewSchema.safeParse(data)
        : withdrawalViewSchema.safeParse(data);
    if (
      !result.success ||
      ('depositId' in result.data
        ? result.data.depositId
        : result.data.withdrawalId) !== requestId ||
      (!session?.isAdmin && result.data.owner !== session?.accountId)
    )
      throw new Error('The server returned invalid ramp request data.');
    return result.data;
  } catch (error) {
    handleApiError(error, 'read-' + kind);
  }
}
